import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { StoreInterfaces } from "../../types/store/StoreInterfaces";
import { UserDetailView } from "../../components/Users";

const ManageUser = () => {
  const { accountId, userId } = useParams<{ accountId: string, userId: string }>(); 
  const administrationAccount = useSelector((state: StoreInterfaces) => state.session.isAdministrator);

  if (!userId) return null;

  return (
    <UserDetailView
      accountId={Number(accountId)} 
      administrationAccount={Boolean(administrationAccount)}
      userId={Number(userId)}
      mode="edit"
      readOnly={false}
    />
  );
};

export default ManageUser;
